module.exports = __webpack_public_path__ + "img/control-left_old.e70ecb24.svg";